export const BOOKING_WIDGET_FEATURE_KEY = 'bookingWidget';
